import React, { useState, useEffect } from 'react';
import './style.css';
import ButtonLoading from '../../atoms/buttonLoading/view';

const InvoiceSettingsForm = ({ initialData = {}, onSubmit }) => {
    const [formData, setFormData] = useState({
        date_from: '',
        date_to: '',
        prefix: '',
        from: 0,
        to: 0,
        resolution: '',
        resolution_date: '', // New field
        type_resolution: 0, // Changed to integer
        type_document_id: 1, // Changed to integer with default
        applies_to: 'both',
        ...initialData,
    });

    useEffect(() => {
        setFormData(prevData => ({ ...prevData, ...initialData }));
    }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    return (
        <div className="invoice-settings-form-container">
            <header className="invoice-settings-header">
                <h3>Configuración de Resolución</h3>
                <p>Configura la numeración y datos de la resolución DIAN.</p>
            </header>

            <form className="invoice-settings-grid">
                <div className="form-group-premium">
                    <label htmlFor="date_from">Fecha Desde</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="date" id="date_from" name="date_from" value={formData.date_from} onChange={handleChange} required />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="date_to">Fecha Hasta</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="date" id="date_to" name="date_to" value={formData.date_to} onChange={handleChange} required />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="prefix">Prefijo</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="text" id="prefix" name="prefix" value={formData.prefix} onChange={(e) => setFormData(p => ({ ...p, prefix: e.target.value.toUpperCase().slice(0, 4) }))} required placeholder="e.g. NCDE" maxLength={4} />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="resolution">Número de Resolución</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="text" id="resolution" name="resolution" value={formData.resolution} onChange={handleChange} required placeholder="123456789" />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="from">Desde (Número Inicial)</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="number" id="from" name="from" value={formData.from} onChange={handleChange} required placeholder="1" />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="to">Hasta (Número Final)</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="number" id="to" name="to" value={formData.to} onChange={handleChange} required placeholder="1000" />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="resolution_date">Fecha de Resolución</label>
                    <div className="input-premium-wrapper">
                        <input className="form-control-premium" type="date" id="resolution_date" name="resolution_date" value={formData.resolution_date} onChange={handleChange} required />
                    </div>
                </div>

                <div className="form-group-premium">
                    <label htmlFor="type_resolution">Tipo de Resolución</label>
                    <div className="input-premium-wrapper">
                        <select className="form-select-premium" id="type_resolution" name="type_resolution" value={formData.type_resolution} onChange={handleChange} required>
                            <option value="">Select Type</option>
                            <option value={1}>1 - Electrónica</option>
                            <option value={2}>2 - Papel</option>
                            <option value={3}>3 - Talonario</option>
                        </select>
                    </div>
                </div>

                <div className="form-group-premium col-span-full">
                    <label htmlFor="type_document_id">Tipo de Documento</label>
                    <div className="input-premium-wrapper">
                        <select className="form-select-premium" id="type_document_id" name="type_document_id" value={formData.type_document_id} onChange={handleChange} required>
                            <option value={1}>1 - Factura</option>
                            <option value={4}>4 - Nota Crédito</option>
                            <option value={5}>5 - Nota Débito</option>
                            <option value={11}>11 - Documento soporte</option>
                            <option value={13}>13 - Nota de ajuste documento soporte (Anulación)</option>
                        </select>
                    </div>
                </div>

                <div className="form-group-premium col-span-full">
                    <label htmlFor="applies_to">Ámbito de Aplicación</label>
                    <div className="input-premium-wrapper">
                        <select className="form-select-premium" id="applies_to" name="applies_to" value={formData.applies_to || 'both'} onChange={handleChange} required>
                            <option value="both">Ambos (POS y Servicios)</option>
                            <option value="pos">Punto de Venta (POS)</option>
                            <option value="services">Servicios</option>
                        </select>
                    </div>
                </div>
            </form>
            <ButtonLoading
                onClick={() => onSubmit(formData)}
                id="invoice-settings-form-loading"
                title="Guardar Resolución"
            />
        </div>
    );
};

export default InvoiceSettingsForm;
